import { render, staticRenderFns } from "./AreaFormRepeater.vue?vue&type=template&id=c5444d44&scoped=true"
import script from "./AreaFormRepeater.vue?vue&type=script&lang=js"
export * from "./AreaFormRepeater.vue?vue&type=script&lang=js"
import style0 from "./AreaFormRepeater.vue?vue&type=style&index=0&id=c5444d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5444d44",
  null
  
)

export default component.exports